import { OfferTaskLabel } from '../route/index.js';

// TODO: We may need more of these to be Zod schemas
// RT-TODO: Rename this to ApplicantOfferRequirementTaskType?
export enum ApplicantOfferRequirementTask {
  Passport = 'Passport',
  PhotoID = 'PhotoID',
  AcademicResults = 'AcademicResults',
  FinalAcademicResults = 'FinalAcademicResults',
  AcademicCertificate = 'AcademicCertificate',
  AcademicTranscript = 'AcademicTranscript',
  EnglishLanguageResults = 'EnglishLanguageResults',
  EnglishLanguageCertificate = 'EnglishLanguageCertificate',
  CV = 'CV',
  ProofOfManagerialExperience = 'ProofOfManagerialExperience',
  ProofOfAddress = 'ProofOfAddress',
  ProofOfNameChange = 'ProofOfNameChange',
  NameAffidavit = 'NameAffidavit',
  BirthCert = 'BirthCert',
  ProofOfImmigrationStatus = 'ProofOfImmigrationStatus',
  LetterOfRecommendation = 'LetterOfRecommendation',
  PersonalStatement = 'PersonalStatement',
  Portfolio = 'Portfolio',
  ResearchProposal = 'ResearchProposal',
  CalendlyInterview = 'CalendlyInterview',
  RecordedInterview = 'RecordedInterview',
  RefereeDetails = 'RefereeDetails',
  Payment = 'Payment',
  ProofOfPayment = 'ProofOfPayment',
  Custom = 'Custom',
  StaffOnly = 'StaffOnly',
}

// TODO: Think of a better name
export enum ApplicantOfferRequirementTaskLevel {
  Off = 'Off',
  PreOffer = 'PreOffer',
  Condition = 'Condition',
  // RT-TODO: Rename to Enrolyment everwhere
  PreEnrolment = 'PreEnrolment',
  AlwaysAvailable = 'AlwaysAvailable',
}

export type RequestableTaskLevel =
  | ApplicantOfferRequirementTaskLevel.PreOffer
  | ApplicantOfferRequirementTaskLevel.PreEnrolment;

export type SettableTaskLevel = Exclude<ApplicantOfferRequirementTaskLevel, ApplicantOfferRequirementTaskLevel.Off>;

/**
 * Maps endpoint URL segments to ApplicantOfferRequirementTask enum values
 */
export const endpointToRequirementTaskEnum = new Map<string, ApplicantOfferRequirementTask>([
  ['passport', ApplicantOfferRequirementTask.Passport],
  ['photo-id', ApplicantOfferRequirementTask.PhotoID],
  ['proof-of-name-change', ApplicantOfferRequirementTask.ProofOfNameChange],
  ['name-affidavit', ApplicantOfferRequirementTask.NameAffidavit],
  ['birth-certificate', ApplicantOfferRequirementTask.BirthCert],
  ['academic-results', ApplicantOfferRequirementTask.AcademicResults],
  ['final-academic-results', ApplicantOfferRequirementTask.FinalAcademicResults],
  ['academic-certificate', ApplicantOfferRequirementTask.AcademicCertificate],
  ['academic-transcript', ApplicantOfferRequirementTask.AcademicTranscript],
  ['english-language-results', ApplicantOfferRequirementTask.EnglishLanguageResults],
  ['english-language-certificate', ApplicantOfferRequirementTask.EnglishLanguageCertificate],
  ['cv', ApplicantOfferRequirementTask.CV],
  ['proof-of-managerial-experience', ApplicantOfferRequirementTask.ProofOfManagerialExperience],
  ['proof-of-address', ApplicantOfferRequirementTask.ProofOfAddress],
  ['proof-of-immigration-status', ApplicantOfferRequirementTask.ProofOfImmigrationStatus],
  ['letter-of-recommendation', ApplicantOfferRequirementTask.LetterOfRecommendation],
  ['personal-statement', ApplicantOfferRequirementTask.PersonalStatement],
  ['research-proposal', ApplicantOfferRequirementTask.ResearchProposal],
  ['portfolio', ApplicantOfferRequirementTask.Portfolio],
  ['referee-details', ApplicantOfferRequirementTask.RefereeDetails],
  ['payment', ApplicantOfferRequirementTask.Payment],
  ['proof-of-payment', ApplicantOfferRequirementTask.ProofOfPayment],
]);

export const ApplicantRequirementTasks: Record<ApplicantOfferRequirementTask, string> = {
  [ApplicantOfferRequirementTask.AcademicCertificate]: OfferTaskLabel.AcademicCertificate,
  [ApplicantOfferRequirementTask.AcademicResults]: OfferTaskLabel.AcademicResults,
  [ApplicantOfferRequirementTask.FinalAcademicResults]: OfferTaskLabel.FinalAcademicResults,
  [ApplicantOfferRequirementTask.AcademicTranscript]: OfferTaskLabel.AcademicTranscript,
  [ApplicantOfferRequirementTask.EnglishLanguageCertificate]: OfferTaskLabel.EnglishLanguageCertificate,
  [ApplicantOfferRequirementTask.EnglishLanguageResults]: OfferTaskLabel.EnglishLanguageResults,
  [ApplicantOfferRequirementTask.Passport]: OfferTaskLabel.Passport,
  [ApplicantOfferRequirementTask.PhotoID]: OfferTaskLabel.PhotoID,
  [ApplicantOfferRequirementTask.CV]: OfferTaskLabel.CV,
  [ApplicantOfferRequirementTask.ProofOfManagerialExperience]: OfferTaskLabel.ProofOfManagerialExperience,
  [ApplicantOfferRequirementTask.LetterOfRecommendation]: OfferTaskLabel.LetterOfRecommendation,
  [ApplicantOfferRequirementTask.PersonalStatement]: OfferTaskLabel.PersonalStatement,
  [ApplicantOfferRequirementTask.ProofOfAddress]: OfferTaskLabel.ProofOfAddress,
  [ApplicantOfferRequirementTask.ProofOfNameChange]: OfferTaskLabel.ProofOfNameChange,
  [ApplicantOfferRequirementTask.NameAffidavit]: OfferTaskLabel.NameAffidavit,
  [ApplicantOfferRequirementTask.BirthCert]: OfferTaskLabel.BirthCert,
  [ApplicantOfferRequirementTask.ProofOfImmigrationStatus]: OfferTaskLabel.ProofOfImmigrationStatus,
  [ApplicantOfferRequirementTask.Portfolio]: OfferTaskLabel.Portfolio,
  [ApplicantOfferRequirementTask.ResearchProposal]: OfferTaskLabel.ResearchProposal,
  [ApplicantOfferRequirementTask.CalendlyInterview]: OfferTaskLabel.CalendlyInterview,
  [ApplicantOfferRequirementTask.RecordedInterview]: OfferTaskLabel.RecordedInterview,
  [ApplicantOfferRequirementTask.RefereeDetails]: OfferTaskLabel.RefereeDetails,
  [ApplicantOfferRequirementTask.Payment]: OfferTaskLabel.Payment,
  [ApplicantOfferRequirementTask.ProofOfPayment]: OfferTaskLabel.ProofOfPayment,
  [ApplicantOfferRequirementTask.Custom]: OfferTaskLabel.Custom,
  [ApplicantOfferRequirementTask.StaffOnly]: OfferTaskLabel.StaffOnly,
};

export enum ApplicantOfferRequirementTaskStatus {
  Assess = 'Assess',
  Satisfied = 'Satisfied',
  Provisional = 'Provisional',
  Condition = 'Condition',
  Exempt = 'Exempt',
  NotSatisfied = 'NotSatisfied',
}

// RT-TODO: Rename to ApplicantOfferRequirementType ?
export enum ApplicantOfferRequirement {
  Identity = 'Identity',
  AcademicRequirement = 'AcademicRequirement',
  EnglishLanguageRequirement = 'EnglishLanguageRequirement',
  Employment = 'Employment',
  ImmigrationHistory = 'ImmigrationHistory',
  References = 'References',
  Portfolio = 'Portfolio',
  ResearchProposal = 'ResearchProposal',
  CalendlyInterview = 'CalendlyInterview',
  RecordedInterview = 'RecordedInterview',
  Finance = 'Finance',
  Custom = 'Custom',
  StaffOnly = 'StaffOnly',
}

export enum ApplicantOfferStatus {
  Applied = 'Applied',
  Draft = 'Draft',
  Conditional = 'Conditional',
  Unconditional = 'Unconditional',
  Withdrawn = 'Withdrawn',
  Rejected = 'Rejected',
  Completed = 'Completed',
}

export enum ApplicantOfferPaymentStatus {
  Request = 'Request',
  Review = 'Review',
  Exempt = 'Exempt',
  Approved = 'Approved',
}

export enum ApplicantStatusReason {
  EntryCriteriaNotMet = 'EntryCriteriaNotMet',
  FailedAcademicAssessment = 'FailedAcademicAssessment',
  FailedCredibilityAssessment = 'FailedCredibilityAssessment',
  FraudulentApplication = 'FraudulentApplication',
  CourseClosure = 'CourseClosure',
  CourseFull = 'CourseFull',
  UnableToOfferCourse = 'UnableToOfferCourse',
  DeadlineHasPassed = 'DeadlineHasPassed',
  ClosedByApplicant = 'ClosedByApplicant',
  AcceptedByApplicant = 'AcceptedByApplicant',
  CompletedByApplicant = 'CompletedByApplicant',
  WithdrawnOnCompletion = 'WithdrawnOnCompletion',
  WrongApplicationForm = 'WrongApplicationForm',
  FailedPreCasInterview = 'FailedPreCasInterview',
  FailedComplianceInterview = 'FailedComplianceInterview',
  NegativeQualificationVerification = 'NegativeQualificationVerification',
  DuplicateApplication = 'DuplicateApplication',
  InactiveApplication = 'InactiveApplication',
  RegionExclusiveToAgent = 'RegionExclusiveToAgent',
  Other = 'Other',
}

export enum ApplicantOfferResponseStatus {
  Accepted = 'Accepted',
  Declined = 'Declined',
}

export enum ApplicantOfferConditionType {
  Conditional = 'Conditional',
  Unconditional = 'Unconditional',
}

export enum ApplicantStatusObjName {
  ConditionalStatus = 'conditionStatus',
  UnconditionalStatus = 'unConditionStatus',
}

export enum ApplicantOfferRequirementTaskActionStatus {
  ToDo = 'To do',
  Done = 'Done',
}

export enum EntryPoint {
  Year0 = 'Year 0',
  Year1 = 'Year 1',
  Year2 = 'Year 2',
  Year3 = 'Year 3',
  Year4 = 'Year 4',
  Year5 = 'Year 5',
  Year6 = 'Year 6',
}

export enum ApplicantOfferPaymentMethod {
  Deposit = 'Deposit',
  Sponsorship = 'Sponsorship',
  SLCFunding = 'SLCFunding',
}

export enum ApplicantOfferPaymentSponsorType {
  UkGovernment = 'UkGovernment',
  BritishCouncil = 'BritishCouncil',
  YourGovernment = 'YourGovernment',
  InternationalOrganisation = 'InternationalOrganisation',
  InternationalCompany = 'InternationalCompany',
}

export enum ScholarshipType {
  FIXED = 'FIXED',
  PERCENTAGE = 'PERCENTAGE',
}
